<template lang="pug">
.fake-data-container
  .fake-data-overlay
  .getting-started-dialog
    a.close(@click="close")
      i.hi.hi-close.hi-12

    p.alert.alert-basic.header
      i.fa.fa-exclamation-circle.mr-5
      | You have not tracked any time.
    h4 Getting started
    ol
      li You need to 
        a(
          :href="download_url"
          target="_blank"
          rel="noopener noreferrer"
        )
          | download the app.
      li Once the app is installed you need to track time to a project.

    h4 Having trouble?
    p
      a.btn.btn-default.btn-sm(
        href="https://support.hubstaff.com"
        target="_blank"
        rel="noopener noreferrer"
      )
        | Visit our Help Center
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ActivitiesFakeMeDataOverlay',
  computed: {
    ...mapState([
      'download_url',
    ]),
  },
  methods: {
    close() {
      this.$emit('closeMe');
    },
  },
};
</script>
